<template>
  <Header
    :showGoBack="showGoBack"
    :creditCard="creditCard"
    :showUserName="showUserName"
    :showUserAvatar="showUserAvatar"
  />

  <Dashboard v-if="currentScreen === 'dashboard'" />
  <Loans v-if="currentScreen === 'loans'" />
  <Deposits v-if="currentScreen === 'deposits'" />
  <Notification v-if="currentScreen === 'notification'" />
  <More v-if="currentScreen === 'more'" />

  <Footer />
</template>

<script setup>
import More from './tabs/More.vue';
import Loans from './tabs/Loans.vue';
import Deposits from './tabs/Deposits.vue';
import Dashboard from './tabs/Dashboard.vue';
import Notification from './tabs/Notification.vue';

import {Header} from '@/components';
import {Footer} from '@/components';

import {computed} from 'vue';
import {useStore} from 'vuex';
import {tabRoutes} from '@/routes';

const store = useStore();

const currentScreen = computed(() => store.getters['tab/screen']);

const showGoBack = computed(() => {
  switch (currentScreen.value) {
    case 'dashboard':
      return false;
    case 'loans':
      return false;
    case tabRoutes.DEPOSITS:
      return false;
    case 'notification':
      return false;
    case 'more':
      return false;
    default:
      return true;
  }
});

const showUserAvatar = computed(() => {
  switch (currentScreen.value) {
    case 'dashboard':
      return true;
    case tabRoutes.LOANS:
      return false;
    case tabRoutes.DEPOSITS:
      return false;
    case tabRoutes.NOTIFICATIONS:
      return false;
    case tabRoutes.MORE:
      return false;
    default:
      return false;
  }
});

const showUserName = computed(() => {
  switch (currentScreen.value) {
    case 'dashboard':
      return true;
    case tabRoutes.LOANS:
      return false;
    case tabRoutes.DEPOSITS:
      return false;
    case tabRoutes.NOTIFICATIONS:
      return false;
    case tabRoutes.MORE:
      return false;
    default:
      return false;
  }
});

const creditCard = computed(() => {
  switch (currentScreen.value) {
    case 'dashboard':
      return true;
    case 'loans':
      return false;
    case tabRoutes.DEPOSITS:
      return false;
    case 'notification':
      return false;
    case 'more':
      return false;
    default:
      return true;
  }
});
</script>
